/*
 * @FileName       : index.tsx
 * @Version        : 1.0
 * @DateOfCreation : 04/23/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Login Page Component for login functionality.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoginCard from './LoginCard';
import { createBrowserHistory } from 'history';
const browserHistory = createBrowserHistory();

export class LoginPage extends Component {
    constructor(props: any) {
        super(props);
        this.state = {
            setCarouselPosition: 0
        };
       // this.CarouselPosition = this.CarouselPosition.bind(this);
        this.onLoginFn = this.onLoginFn.bind(this);
    }
    onLoginFn(){
        browserHistory.push('/current-report');
    }

    render() {
        return (
            <div className="login-container center-flex" style={{backgroundColor: '#0065a4'}}>
                <div style={{ width: '100%', margin:'0 auto' , height: '100vh', paddingTop: 100 }}>
                    <LoginCard />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => (
    {}
);
export default connect(mapStateToProps)(LoginPage);